import { shape, string } from 'prop-types'
import { CustomCouplingRuleModel } from '../../models/vehicle/custom-coupling-rule-model'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { customCouplingRuleTypePropType } from './custom-coupling-rule-type-prop-type'

const { ASSET_ID, CUSTOM_COUPLING_RULE_ID, RULE_TYPE, VALID_TO, VEHICLE_ID } = CustomCouplingRuleModel

export const customCouplingRulePropType = shape({
    [CUSTOM_COUPLING_RULE_ID]: string.isRequired,
    [ASSET_ID]: string.isRequired,
    [VEHICLE_ID]: string.isRequired,
    [RULE_TYPE]: customCouplingRuleTypePropType,
    [VALID_TO]: iso8601PropType.isRequired
})
